import { CommonModule } from "@angular/common";
import { Component, inject, signal } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/pages/auth";
import { StudentCourseService } from "src/app/services/api/student-course.service";
import { SweetAlertService } from "src/app/services/sweet-alert-service/sweet-alert.service";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { LabelMode } from "src/utils/label-mode.enum";
import { SetError } from "src/utils/set-error.validator";

@Component({
  selector: "app-review",
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: "./review.component.html",
  styleUrl: "./review.component.scss",
})
export class ReviewComponent {
  #dialogRef = inject(MatDialogRef<boolean>);
  #fb = inject(FormBuilder);
  #authService = inject(AuthService);
  #studentCourseService = inject(StudentCourseService);
  #translate = inject(TranslateService);

  #toastService = inject(ToastService);
  #swalService = inject(SweetAlertService);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;
  LabelMode = LabelMode;
  isLoading = signal<boolean>(false);

  currentUser = this.#authService.currentUser()?.user;
  fileUrl = environment.apiFileUrl;

  error: any;

  ngOnInit(): void {
    this.buildForm();
    // this.fetchData();
  }

  buildForm() {
    this.form = this.#fb.group({
      review: [null, Validators.required],
      score: [0, Validators.required],
      student_id: [this.data.student_id, Validators.required],
      course_id: [this.data.course_id, Validators.required],
      student_course_id: [this.data.id, Validators.required],
      // students: this.#fb.array([]),
    });
  }

  async onSubmit() {
    this.error = {};
    if (this.form.invalid) {
      this.error = SetError(this.form);
      return;
    }
    let payload = this.form.getRawValue();

    try {
      const reviewService = await lastValueFrom(
        this.#studentCourseService.review(payload)
      );
      this.#toastService.toastSuccess(
        this.#translate.instant("ONLINE_CLASS.COMMENT_SUCCESS")
      );
      setTimeout(() => {
        this.onClose();
      }, 500);
    } catch (error: any) {
      this.#toastService.toastError(
        error.error.errors || this.#translate.instant("VALIDATOR.ERROR")
      );
    }
  }

  onClose() {
    this.#dialogRef.close(true);
  }
}
